import {Injectable} from '@angular/core';
import {Individu, IndividuService} from "@Common/core/services";
import {Roles} from "app/archivage/common/services/helper-individu/helper-individu.model";
import {ReplaySubject} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class HelperIndividuService {
  private static gestionnaire = false;
  private static superviseur = false;
  private static admin = false;

  private static initDone = new ReplaySubject<Boolean>(1);
  public static initDone$ = HelperIndividuService.initDone.asObservable();

  constructor(private individuService: IndividuService) {
  }

  set individu(individu: Individu) {
    HelperIndividuService.gestionnaire = this.individuService.hasRole(individu, Roles.gestionnaire);
    HelperIndividuService.superviseur = this.individuService.hasRole(individu, Roles.superviseur);
    HelperIndividuService.admin = this.individuService.hasRole(individu, Roles.admin);

    if (HelperIndividuService.admin) { HelperIndividuService.superviseur = true; }
    if (HelperIndividuService.superviseur) { HelperIndividuService.gestionnaire = true; }

    HelperIndividuService.initDone.next(true);
  }

  get isGestionnaire() {
    return HelperIndividuService.gestionnaire;
  }

  get isSuperviseur() {
    return HelperIndividuService.superviseur;
  }

  get isAdmin() {
    return HelperIndividuService.admin;
  }
}
